import * as React from 'react';
import styled, { css } from 'styled-components';

import { GridItem } from './GridItem';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  /** If set, grid will fill vertical space available to it. */
  fill?: boolean;
}

const GridBase = (props: IProps) => 
  <div className={props.className}>{props.children}</div>

const GridStyled = styled(GridBase)`
  display: grid;
  grid-template-columns: repeat(6, calc(16.66% - 6px));
  grid-column-gap: 8px;
  ${p => p.fill && css`
    flex: 1;
  `}
`

const Grid = (props: IProps) => <GridStyled {...props}/>

Grid.Item = GridItem;

export { Grid }
